import { MinAndMaxLengthInputs } from '@/features/transaction_items/components/Form/TextAndAlphanumeric/MinAndMaxLengthInputs/MinAndMaxLengthInputs';
import { Placeholder } from '@/features/transaction_items/components/Form/TextAndAlphanumeric/Placeholder/Placeholder';
import { TransactionItemDrawerMode } from '@/features/transaction_items/List/type';
import { FC, memo } from 'react';

export type Props = {
  mode: TransactionItemDrawerMode;
};

export const TextAndAlphanumeric: FC<Props> = memo(({ mode }) => {
  return (
    <>
      <MinAndMaxLengthInputs mode={mode} />
      <Placeholder mode={mode} />
    </>
  );
});
TextAndAlphanumeric.displayName = 'TextAndAlphanumeric';
